module.exports = __webpack_public_path__ + "img/iphone-charging-NETHERLANDS-en.7b01c1c5.webp";